import moreIcon from './../Assets/icons/moreIcon.svg';
import editIcon from './../Assets/icons/Un-Checkbox.svg';

export const TODAYS_FOLLOWUP_LIST_HEADERS = [

  "Lead Code",
  "Lead Name",
  "Mobile No",
  "Product Name",
  "Lead Priority",
  "SubProduct Name",
  "Make",
  "Model",
  "Stage",
  "Source",
  "Created Date",
  "Status",
  "Action"
];

export const TODAYS_FOLLOWUP_LIST_DATA = [
  { 
    code: "001", 
    leadName: "John Doe", 
    mobileNo: "1234567890", 
    productName: "Product A", 
    make: "Make X", 
    model: "Model Y", 
    variant: "Variant Z", 
    source: "Website", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
  { 
    code: "002", 
    leadName: "Jane Smith", 
    mobileNo: "0987654321", 
    productName: "Product B", 
    make: "Make Y", 
    model: "Model Z", 
    variant: "Variant X", 
    source: "Referral", 
    status: "Completed", 
    actions: "Edit/Delete" 
  },
  { 
    code: "003", 
    leadName: "Alice Johnson", 
    mobileNo: "1122334455", 
    productName: "Product C", 
    make: "Make Z", 
    model: "Model X", 
    variant: "Variant Y", 
    source: "Email", 
    status: "In Progress", 
    actions: "Edit/Delete" 
  },
  { 
    code: "004", 
    leadName: "Bob Brown", 
    mobileNo: "2233445566", 
    productName: "Product D", 
    make: "Make W", 
    model: "Model V", 
    variant: "Variant U", 
    source: "Social Media", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
  { 
    code: "005", 
    leadName: "Charlie Davis", 
    mobileNo: "3344556677", 
    productName: "Product E", 
    make: "Make V", 
    model: "Model U", 
    variant: "Variant T", 
    source: "Referral", 
    status: "Completed", 
    actions: "Edit/Delete" 
  },
  { 
    code: "006", 
    leadName: "Diane Wilson", 
    mobileNo: "4455667788", 
    productName: "Product F", 
    make: "Make U", 
    model: "Model T", 
    variant: "Variant S", 
    source: "Website", 
    status: "In Progress", 
    actions: "Edit/Delete" 
  },
  { 
    code: "007", 
    leadName: "Edward Thomas", 
    mobileNo: "5566778899", 
    productName: "Product G", 
    make: "Make T", 
    model: "Model S", 
    variant: "Variant R", 
    source: "Email", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
  { 
    code: "008", 
    leadName: "Fiona White", 
    mobileNo: "6677889900", 
    productName: "Product H", 
    make: "Make S", 
    model: "Model R", 
    variant: "Variant Q", 
    source: "Social Media", 
    status: "Completed", 
    actions: "Edit/Delete" 
  },
  { 
    code: "009", 
    leadName: "George Harris", 
    mobileNo: "7788990011", 
    productName: "Product I", 
    make: "Make R", 
    model: "Model Q", 
    variant: "Variant P", 
    source: "Website", 
    status: "In Progress", 
    actions: "Edit/Delete" 
  },
  { 
    code: "010", 
    leadName: "Hannah Clark", 
    mobileNo: "8899001122", 
    productName: "Product J", 
    make: "Make Q", 
    model: "Model P", 
    variant: "Variant O", 
    source: "Referral", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
  { 
    code: "011", 
    leadName: "Ivan Martinez", 
    mobileNo: "9900112233", 
    productName: "Product K", 
    make: "Make P", 
    model: "Model O", 
    variant: "Variant N", 
    source: "Email", 
    status: "Completed", 
    actions: "Edit/Delete" 
  },
  { 
    code: "012", 
    leadName: "Jack Robinson", 
    mobileNo: "0011223344", 
    productName: "Product L", 
    make: "Make O", 
    model: "Model N", 
    variant: "Variant M", 
    source: "Social Media", 
    status: "In Progress", 
    actions: "Edit/Delete" 
  },
  { 
    code: "013", 
    leadName: "Karen Young", 
    mobileNo: "1122334455", 
    productName: "Product M", 
    make: "Make N", 
    model: "Model M", 
    variant: "Variant L", 
    source: "Website", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
  { 
    code: "014", 
    leadName: "Liam Walker", 
    mobileNo: "2233445566", 
    productName: "Product N", 
    make: "Make M", 
    model: "Model L", 
    variant: "Variant K", 
    source: "Referral", 
    status: "Completed", 
    actions: "Edit/Delete" 
  },
  { 
    code: "015", 
    leadName: "Megan King", 
    mobileNo: "3344556677", 
    productName: "Product O", 
    make: "Make L", 
    model: "Model K", 
    variant: "Variant J", 
    source: "Email", 
    status: "In Progress", 
    actions: "Edit/Delete" 
  },
  { 
    code: "016", 
    leadName: "Nathan Wright", 
    mobileNo: "4455667788", 
    productName: "Product P", 
    make: "Make K", 
    model: "Model J", 
    variant: "Variant I", 
    source: "Social Media", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
  { 
    code: "017", 
    leadName: "Olivia Lewis", 
    mobileNo: "5566778899", 
    productName: "Product Q", 
    make: "Make J", 
    model: "Model I", 
    variant: "Variant H", 
    source: "Website", 
    status: "Completed", 
    actions: "Edit/Delete" 
  },
  { 
    code: "018", 
    leadName: "Patrick Lee", 
    mobileNo: "6677889900", 
    productName: "Product R", 
    make: "Make I", 
    model: "Model H", 
    variant: "Variant G", 
    source: "Referral", 
    status: "In Progress", 
    actions: "Edit/Delete" 
  },
  { 
    code: "019", 
    leadName: "Quinn Allen", 
    mobileNo: "7788990011", 
    productName: "Product S", 
    make: "Make H", 
    model: "Model G", 
    variant: "Variant F", 
    source: "Email", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
  { 
    code: "020", 
    leadName: "Rachel Scott", 
    mobileNo: "8899001122", 
    productName: "Product T", 
    make: "Make G", 
    model: "Model F", 
    variant: "Variant E", 
    source: "Social Media", 
    status: "Completed", 
    actions: "Edit/Delete" 
  },
  { 
    code: "021", 
    leadName: "Samuel Adams", 
    mobileNo: "9900112233", 
    productName: "Product U", 
    make: "Make F", 
    model: "Model E", 
    variant: "Variant D", 
    source: "Website", 
    status: "In Progress", 
    actions: "Edit/Delete" 
  },
  { 
    code: "022", 
    leadName: "Tina Hill", 
    mobileNo: "0011223344", 
    productName: "Product V", 
    make: "Make E", 
    model: "Model D", 
    variant: "Variant C", 
    source: "Referral", 
    status: "Pending", 
    actions: "Edit/Delete" 
  },
];


export const TODAYS_FOLLOWUP_LIST_KEY_MAPPING = {
  "Lead Code": "lead_code",
  "Lead Name": "full_name",
  "Mobile No": "mobile_no",
  "Product Name": "product_name",
  "Lead Priority": "priority_name",
  "SubProduct Name":"subproduct_name",
  "Make": "make_name",
  "Model": "model_name",
  "Stage": "stage",
  "Source": "source_name",
  "Created Date":"created_at",
  "Status": "status_name",
  "Action": [
    // { type: "edit", icon: editIcon, label: "Edit" },
    { type: "more", icon: moreIcon, label: "More" }
  ]
};
